import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { ConcessionType, PaymentConcessionMasterProps } from '../types';
import { getFullPaymentConcessionColumns } from '../utils/FullPaymentConcessionColumns';
import EditPaymentConcessionModal from './EditPaymentConcessionModal';
import { SnackbarSeverityType } from '../../../enums';
import tableColumnUtils from '../../../utils/tableColumnUtils';

interface FullPaymentConcessionTableProps {
  activeTab: ConcessionType;
  paymentConcessionMasterData: PaymentConcessionMasterProps[] | undefined;
  gradeOptions: { label: string; value: string }[];
  selectedAcademicYear: string;
  loggedInUser: any;
  fetchPaymentConcessionMaster: () => Promise<void>;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
  allPaymentConcessionMasterGrades: string[];
}

const FullPaymentConcessionTable = ({
  activeTab,
  paymentConcessionMasterData,
  gradeOptions,
  selectedAcademicYear,
  loggedInUser,
  fetchPaymentConcessionMaster,
  showToast,
  allPaymentConcessionMasterGrades
}: FullPaymentConcessionTableProps) => {
  const [
    isEditPaymentConcessionModalOpen,
    setIsEditPaymentConcessionModalOpen
  ] = useState(false);
  const [selectedPaymentConcessionData, setSelectedPaymentConcessionData] =
    useState<PaymentConcessionMasterProps>();

  const handlePaymentConcessionEdit = (
    selectedRow: PaymentConcessionMasterProps
  ) => {
    setSelectedPaymentConcessionData(selectedRow);
    setIsEditPaymentConcessionModalOpen(true);
  };

  const columns = getFullPaymentConcessionColumns(
    activeTab,
    handlePaymentConcessionEdit
  );

  return (
    <>
      <DataGrid
        rowHeight={50}
        rows={paymentConcessionMasterData}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />

      {isEditPaymentConcessionModalOpen && (
        <EditPaymentConcessionModal
          activeTab={activeTab}
          gradeOptions={gradeOptions}
          isEditPaymentConcessionModalOpen={isEditPaymentConcessionModalOpen}
          selectedPaymentConcessionData={selectedPaymentConcessionData}
          selectedAcademicYear={selectedAcademicYear}
          loggedInUser={loggedInUser}
          fetchPaymentConcessionMaster={fetchPaymentConcessionMaster}
          setIsEditPaymentConcessionModalOpen={
            setIsEditPaymentConcessionModalOpen
          }
          showToast={showToast}
          allPaymentConcessionMasterGrades={allPaymentConcessionMasterGrades}
        />
      )}
    </>
  );
};

export default FullPaymentConcessionTable;
